module.exports = __webpack_public_path__ + "img/Emmanuel.4f9cc3b9.jpg";